import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {AuthService} from '../../../services/auth.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  selector: 'app-auth-dialog',
  templateUrl: './auth-dialog.component.html',
  styleUrls: ['./auth-dialog.component.scss']
})
export class AuthDialogComponent implements OnInit {
  public authNumber: any;
  private readonly userId: number;
  loading = false;
  @ViewChild('n1', {static: false}) number1: ElementRef;
  @ViewChild('n2', {static: false}) number2: ElementRef;
  @ViewChild('n3', {static: false}) number3: ElementRef;
  @ViewChild('n4', {static: false}) number4: ElementRef;
  @ViewChild('n5', {static: false}) number5: ElementRef;
  @ViewChild('n6', {static: false}) number6: ElementRef;

  constructor(private authService: AuthService, private dialogRef: MatDialogRef<AuthDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, public toastMessagesService: ToastMessagesService) {
    this.userId = this.data.userId;

    this.authNumber = {
      num1: null,
      num2: null,
      num3: null,
      num4: null,
      num5: null,
      num6: null,
    };
  }

  ngOnInit() { }

  filledNumbers(): boolean {
    return this.authNumber.num1 === null || this.authNumber.num2 === null ||
      this.authNumber.num3 === null || this.authNumber.num4 === null || this.authNumber.num5 === null || this.authNumber.num6 === null;
  }

  async checkCode() {
    try {
      this.loading = true;
      const result = await this.authService.checkCode(this.authNumber, this.userId);
      this.dialogRef.close(result);
    } catch (e) {
      this.toastMessagesService.toastMessages('Ο αριθμός που πληκτρολογήσατε δεν είναι σωστός');
      this.clearNumbers();
    } finally {
      this.loading = false;
    }
  }

  clearNumbers() {
    this.authNumber.num1 = null;
    this.authNumber.num2 = null;
    this.authNumber.num3 = null;
    this.authNumber.num4 = null;
    this.authNumber.num5 = null;
    this.authNumber.num6 = null;
  }

  keyFocus($event: any, index: number) {
    switch (index) {
      case 1:
        this.number2.nativeElement.focus();
        break;
      case 2:
        this.number3.nativeElement.focus();
        break;
      case 3:
        this.number4.nativeElement.focus();
        break;
      case 4:
        this.number5.nativeElement.focus();
        break;
      case 5:
        this.number6.nativeElement.focus();
        break;
    }
  }
}
